import { render, staticRenderFns } from "./AffRequestRespModal.vue?vue&type=template&id=e6c2a4d8&"
import script from "./AffRequestRespModal.vue?vue&type=script&lang=js&"
export * from "./AffRequestRespModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports